"use client";

import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { PRODUCTS_LIST_CLASSES } from "./constants";

export const ProductsGridContainer = styled((props: BoxProps) => <Box {...props} />)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(4),
    [`& .${PRODUCTS_LIST_CLASSES.productGrid}`]: {
      width: "100%",
    },
  }),
);
